import React from 'react';

import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';

interface RodapeProps {
  selecionadas: number;
  resumo: string;
  onLimpar: () => void;
  onCancelar: () => void;
  onAplicar: () => void;
  aplicarDesabilitado?: boolean;
  onSelecionarTodos?: () => void;
}

/**
 * Rodape fixo dos seletores de entidade no mobile: resumo da selecao +
 * Cancelar/Aplicar.
 *
 * "Limpar" e "Selecionar todos" sao links no resumo, nao botoes: o desktop tem
 * os tres lado a lado no rodape, mas em 360px isso espreme os alvos abaixo do
 * minimo tocavel. A capacidade e a mesma.
 */
export default function Rodape({
  selecionadas,
  resumo,
  onLimpar,
  onCancelar,
  onAplicar,
  aplicarDesabilitado = false,
  onSelecionarTodos,
}: RodapeProps) {
  return (
    <div className="windx-seletor-sheet-rodape">
      <p className="windx-seletor-sheet-resumo">
        {resumo}
        {onSelecionarTodos && (
          <button
            type="button"
            className="windx-seletor-sheet-link"
            onClick={onSelecionarTodos}
          >
            Selecionar todos
          </button>
        )}
        {selecionadas > 0 && (
          <button type="button" className="windx-seletor-sheet-link" onClick={onLimpar}>
            Limpar
          </button>
        )}
      </p>
      <div className="windx-seletor-sheet-acoes">
        <SheetActionButton variant="secondary" onClick={onCancelar}>
          Cancelar
        </SheetActionButton>
        <SheetActionButton
          variant="confirm"
          onClick={onAplicar}
          disabled={aplicarDesabilitado}
        >
          Aplicar
        </SheetActionButton>
      </div>
    </div>
  );
}
